import { createAction, props } from '@ngrx/store';
import { InvitationSearch } from '../models/invitation.model';

export const setInvitationsSearch = createAction('[Search Invitations Component] setInvitationsSearch', props<InvitationSearch>());
